import { Param } from "@senx/discovery-widgets";

export interface HCParams extends Param {
    HCParams: Highcharts.Options;
}